module Meevo.Components.Controls.SmartMover {
    import IAlertManagerEmployee = Meevo.Model.IAlertManagerEmployee;
    import IAlertUserLineItem = Meevo.Model.IAlertUserLineItem;
    import EmployeeListItem = Meevo.Model.EmployeeListItem;
    export class AlertsManagerEmployeeCollection extends SmartMoverApiCollection<IAlertManagerEmployee> implements IApiCollection<IAlertManagerEmployee> {

        protected get url() {
            return 'Employee';
        }

        get value(): ModelValueType[] {
            return this.selectedModels
                .map((selectedModel) => ({
                    id: selectedModel.id,
                    user_Tid: selectedModel.get('id'),
                    displayName: selectedModel.displayName,
                    employeeCode: selectedModel.get('employeeCode')
                }))
        }

        protected modelIsSelected(model: CollectionModel<IAlertManagerEmployee>, modelValues: ModelValueType[]): boolean {
            return modelValues.some((item: IAlertUserLineItem | string) => {
                if (typeof item === "string") {
                    return item === model.id;
                }
                return item.user_TId === model.id;
            })
        }
    }
}
